<div class="min-vh-100 bg-light">
  <app-header [page]="'Admin'"></app-header>

  <main class="container py-4">

    <div class="d-flex justify-content-between align-items-center mb-3">
      <div>
        <h4 class="fw-bold mb-0">Country Change Requests</h4>
        <div class="text-muted small">Review user relocation requests and risk signals</div>
      </div>

      <div>
        <a routerLink="/admin/compliance-flags" class="btn btn-outline-dark btn-sm">
          Open Compliance Flags
        </a>
      </div>
    </div>

    <form [formGroup]="searchForm" (ngSubmit)="submitSearch()">
      <div class="card border-0 shadow-sm mb-3">
        <div class="card-body d-flex flex-wrap gap-2">

          <select class="form-select form-select-sm" style="width:150px" formControlName="status">
            <option value="">All Statuses</option>
            <option value="Pending">Pending</option>
            <option value="Approved">Approved</option>
            <option value="Applied">Applied</option>
            <option value="Rejected">Rejected</option>
          </select>

          <input class="form-control form-control-sm"
                 style="width:220px"
                 placeholder="Search user/email"
                 formControlName="search" />

          <input class="form-control form-control-sm"
                 style="width:120px"
                 placeholder="From"
                 formControlName="currentCountryCode" />

          <input class="form-control form-control-sm"
                 style="width:120px"
                 placeholder="To"
                 formControlName="requestedCountryCode" />

          <select class="form-select form-select-sm" style="width:150px" formControlName="riskLevel">
            <option value="">All Risk Levels</option>
            <option value="Low">Low</option>
            <option value="Medium">Medium</option>
            <option value="High">High</option>
            <option value="Critical">Critical</option>
          </select>

          <select class="form-select form-select-sm" style="width:170px" formControlName="requiresManualReview">
            <option value="">Manual Review?</option>
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>

          <select class="form-select form-select-sm" style="width:170px" formControlName="hasOpenComplianceFlags">
            <option value="">Open Flags?</option>
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>

          <button class="btn btn-outline-primary btn-sm">Search</button>
          <button type="button" class="btn btn-outline-secondary btn-sm" (click)="resetFilters()">Reset</button>

        </div>
      </div>
    </form>

    <div class="card border-0 shadow-sm">
      <div class="card-body p-0">

        <div *ngIf="loading" class="p-4 text-center text-muted">
          Loading...
        </div>

        <div *ngIf="!loading" class="table-responsive">
          <table class="table table-hover mb-0">
            <thead class="table-light">
              <tr class="small text-muted">
                <th>User</th>
                <th>From</th>
                <th>To</th>
                <th>Status</th>
                <th>Risk</th>
                <th>Flags</th>
                <th>Requested</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let item of requests">
                <td>
                  <div class="fw-semibold">{{ getDisplayName(item) }}</div>
                  <div class="small text-muted" *ngIf="getDisplayEmail(item)">
                    {{ getDisplayEmail(item) }}
                  </div>
                </td>

                <td>{{ item.currentCountryCode }}</td>
                <td>{{ item.requestedCountryCode }}</td>

                <td>
                  <span class="badge" [ngClass]="getStatusBadgeClass(item.status)">
                    {{ item.status }}
                  </span>
                </td>

                <td>
                  <span class="badge" [ngClass]="getRiskBadgeClass(item.riskLevel)">
                    {{ item.riskLevel || 'N/A' }}
                    <ng-container *ngIf="item.riskScore !== undefined && item.riskScore !== null">
                      ({{ item.riskScore }})
                    </ng-container>
                  </span>

                  <div class="small text-muted mt-1" *ngIf="item.requiresManualReview">
                    Manual review
                  </div>
                </td>

                <td>
                  <span class="badge text-bg-dark">
                    {{ item.openComplianceFlagsCount || 0 }}
                  </span>
                </td>

                <td>{{ getRequestedDate(item) | date:'short' }}</td>

                <td class="text-end">
                  <div class="btn-group btn-group-sm">
                    <button class="btn btn-outline-secondary" (click)="view(item)">View</button>

                    <button *ngIf="item.status === 'Pending'"
                      class="btn btn-outline-success"
                      (click)="approve(item)">
                      Approve
                    </button>

                    <button *ngIf="item.status === 'Pending'"
                      class="btn btn-outline-danger"
                      (click)="reject(item)">
                      Reject
                    </button>
                  </div>
                </td>
              </tr>

              <tr *ngIf="requests.length === 0">
                <td colspan="8" class="text-center text-muted p-3">
                  No requests found
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>

    <div class="d-flex justify-content-end mt-3" *ngIf="meta">
      <div class="btn-group btn-group-sm">
        <button class="btn btn-outline-secondary"
          [disabled]="meta.currentPage === 1"
          (click)="load(meta.currentPage - 1)">
          Prev
        </button>

        <button class="btn btn-outline-secondary disabled">
          Page {{ meta.currentPage }} / {{ meta.totalPages }}
        </button>

        <button class="btn btn-outline-secondary"
          [disabled]="meta.currentPage === meta.totalPages"
          (click)="load(meta.currentPage + 1)">
          Next
        </button>
      </div>
    </div>

  </main>
</div>